export default __webpack_public_path__ + "static/media/location.e9c3d8cc.png";